
import { defineComponent } from 'vue';
import HiddenAccentButton from '@/components/HiddenAccentButton.vue';
import TopBlock from '@/components/TopBlock.vue';

export default defineComponent({
  name: 'Menu',
  data() {
    return {
      sent: false,
    };
  },
  components: { HiddenAccentButton, TopBlock },
});
